<template>
    <div class="h-screen w-full flex items-center justify-center">
        <div 
            class="flex flex-col rounded-2xl bg-white items-center shadow-xl h-[500px] w-[340px]
                sm:w-[400px]
                xl:w-[450px]"
        > 
            <div class="font-bold text-2xl mt-14 mb-5">
                Введите код авторизации
            </div>
            <div class="text-xs m-0 mb-3">
                Введите код, который мы выслали на {{ userEmail }}
            </div>
            <div v-if="!isUserCodeValid" class="my-3 px-2 border border-red-300 h-10 rounded-md flex items-center justify-center">
                <ExclaminationCircle class="mr-1"/>
                <div class="text-xs">
                    {{ message }}
                </div>
            </div>
            <form class="max-w-sm mx-auto mb-6" number-code-form>
                <div class="flex mb-2 space-x-2 rtl:space-x-reverse">
                    <input v-for="index in CODE_LENGTH" v-bind:key="index" type="tel" pattern="[0-9]" maxlength="1" autocomplete="off" number-code-init :id="'code-'+ index" class="block w-9 h-9 py-3 text-sm text-center outline-none border-2 border-black focus:border-blue-600 rounded-md"/>
                </div>
            </form>
            <div
                 v-on:click="submitCode" 
                 class="h-10 w-3/5 bg-blue-600 text-white text-sm flex items-center justify-center select-none cursor-pointer hover:bg-blue-700 rounded-md"
            >
                ПОДТВЕРДИТЬ
            </div>
            <div>
                <div v-if="isSendButtonActive" class="text-xs flex justify-center w-full mt-3 cursor-pointer select-none hover:text-blue-700" v-on:click="sendAcceptionCode">
                    Отправить новый код
                </div>
                <div v-else>
                    <div v-if="this.currentTime >= 10" class="text-xs flex justify-center w-full mt-3 select-none">Отправить новый код через 0:{{this.currentTime}}</div>
                    <div v-else class="text-xs flex justify-center w-full mt-3 select-none">Отправить новый код через 0:0{{this.currentTime}}</div>
                </div> 
            </div>

        </div>

    </div>

</template>

<script>
import setInputIntercations from '@/service/inputUtils';
import ExclaminationCircle from '../../components/UI/ExclaminationCircle.vue';
import {Api} from '@/service/api';

export default {
    name: "CodeAcception",
    components: {
        ExclaminationCircle
    },
    data() {
        return {
            CODE_LENGTH: 6,
            acceptionCode: "",
            isSendButtonActive: false,
            timer: null,
            currentTime: 15,
            isUserCodeValid: true,
            message: "",
            userEmail: ""
        }
    },
    methods: {
        submitCode: async function() {
            let userCode = ""
            document.querySelectorAll('[number-code-init]').forEach(val=>{
                userCode += val.value
            })
            let isCodeValid = await Api.validateUserCode(userCode)
            if (!isCodeValid.is_valid) {
                this.isUserCodeValid = false
                this.message = isCodeValid.message
            }
            else {
                const queryParams = this.$route.query;

                if (queryParams && queryParams.redirect) {
                    if (queryParams.redirect === 'subscriptions') {
                        this.$router.push({name: "SubscriptionPricingView", query: {plan: queryParams.plan, length: queryParams.length}})
                    }
                }
                else {
                    this.$router.push({name: "WorkspaceView"})
                }
                this.stopTimer()
            }
        },
        startTimer(time) {
            this.currentTime = time
            this.timer = setInterval(() => {
                this.currentTime--
            }, 1000)
            this.isSendButtonActive = false
        },
        async sendAcceptionCode() {
            const userCode = await Api.resendUserCode()

            console.log(userCode)

            this.currentTime = userCode.user_code?.remaining_time_to_resend

            this.startTimer(this.currentTime)

        },
        stopTimer() {
            clearTimeout(this.timer)
            this.isSendButtonActive = true
        },
    },
    mounted: async function() {
        const userData = await Api.getUserInfo()

        if (userData.status === "error" && userData.code === 403) {
            this.$router.push({name: "WorkspaceView"})
            return
        }

        const userInfo = userData.data

        const isUserSubmitted = userInfo['is_user_confirmed']

        this.currentTime = userInfo['user_code']['remaining_time_to_resend']

        console.log(userData)

        this.userEmail = userInfo['email']
        
        if (isUserSubmitted) {
            this.$router.push({name: "WorkspaceView"})
            return
        }
        setInputIntercations()
        this.startTimer(this.currentTime)

    },
    watch: {
        currentTime(time) {
            if (time ===  0) {
                this.stopTimer()
            }
        }
    }
}
</script>